/**
 * Navigation JavaScript
 */
document.addEventListener('DOMContentLoaded', function() {
  // スクロールヘッダーの処理
  const scrollHeader = document.querySelector('.js-scroll-header')
  if (scrollHeader) {
    window.addEventListener('scroll', function() {
      if (window.scrollY > 50) {
        scrollHeader.classList.add('bg-primary/80')
        scrollHeader.classList.remove('bg-transparent')
      } else {
        scrollHeader.classList.remove('bg-primary/80')
        scrollHeader.classList.add('bg-transparent')
      }
    })
  }

  // Mobile menu toggle
  const menuButton = document.querySelector('#menu-toggle')
  const mobileMenu = document.querySelector('#mobile-menu')
  const menuIcon = document.querySelector('.menu-icon')
  const closeIcon = document.querySelector('.close-icon')
  const body = document.body

  // 初期状態でモバイルメニューを非表示にし、適切なクラスを設定
  if (mobileMenu) {
    mobileMenu.classList.add('hidden', '-translate-y-full')
  }

  // スクロールを有効にする関数
  function enableScroll() {
    body.style.overflow = ''
    body.style.height = ''
    body.style.position = ''
    body.style.width = ''
    body.style.top = ''
  }

  // スクロールを無効にする関数
  function disableScroll() {
    const scrollY = window.scrollY
    body.style.position = 'fixed'
    body.style.top = `-${scrollY}px`
    body.style.width = '100%'
    body.style.overflow = 'hidden'
  }

  if (menuButton && mobileMenu) {
    menuButton.addEventListener('click', function() {
      // メニューの表示/非表示を切り替え
      const isHidden = mobileMenu.classList.contains('hidden')

      if (isHidden) {
        // メニューを表示
        mobileMenu.classList.remove('hidden')
        // 少し遅延させてアニメーションを適用
        setTimeout(() => {
          mobileMenu.classList.remove('-translate-y-full')
          mobileMenu.classList.add('translate-y-0')
        }, 10)
        // スクロールを無効化
        disableScroll()
      } else {
        // メニューを非表示
        mobileMenu.classList.remove('translate-y-0')
        mobileMenu.classList.add('-translate-y-full')
        // アニメーションが終わったら非表示にする
        setTimeout(() => {
          mobileMenu.classList.add('hidden')
          // スクロールを有効化
          enableScroll()
        }, 300) // トランジションの時間と同じ
      }

      // メニューアイコンの切り替え
      if (menuIcon && closeIcon) {
        menuIcon.classList.toggle('hidden')
        closeIcon.classList.toggle('hidden')
      }
    })

    // メニューリンクをクリックしたときにメニューを閉じる
    const menuLinks = mobileMenu.querySelectorAll('a')
    menuLinks.forEach(link => {
      link.addEventListener('click', function() {
        mobileMenu.classList.remove('translate-y-0')
        mobileMenu.classList.add('-translate-y-full')
        menuIcon.classList.remove('hidden')
        closeIcon.classList.add('hidden')

        // アニメーションが終わったら非表示にする
        setTimeout(() => {
          mobileMenu.classList.add('hidden')
          // スクロールを有効化
          enableScroll()
        }, 300) // トランジションの時間と同じ
      })
    })
  }
})
